import _ from 'lodash'

export default unergieFooter

/** @ngInject */
function unergieFooter($q, $uibModal, $stateParams, $timeout, ReferencesService, TariffResource, ErrorCatcher) {
    return ({
        restrict: 'E',
        template: require('./unergieFooter.jade')(),
        link: ($scope) => {
            let tariffInfoPromise = $q.resolve({})
            let availablePowersPromise = $q.resolve({})

            $scope.openPriceModal = () => {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    component: 'priceModal',
                    resolve: {
                        availablePowers: availablePowersPromise,
                        tariffInfo: tariffInfoPromise,
                    },
                })
            }

            const activate = () => {
                availablePowersPromise = ReferencesService.getRefPromise('ot-ps').catch((error) => {
                    ErrorCatcher.catchError(error)
                    $q.reject(error)
                })

                tariffInfoPromise = TariffResource.getTariff().$promise.then((result) => {
                    const toUpperCaseKey = (val, key) => key.toUpperCase()
                    return _.mapValues(result, (val) => _.mapKeys(val, toUpperCaseKey))
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    $q.reject(error)
                })

                $timeout(() => {
                    if ($stateParams.shouldOpenPriceForm) {
                        $scope.openPriceModal()
                    }
                })
            }
            activate()
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/footer/unergieFooter.js